// extracted by mini-css-extract-plugin
export default {"loader_container":"Loader_loader_container__sNMNN","spinner":"Loader_spinner__pookH","spin":"Loader_spin__sAjWQ","text":"Loader_text__A1H4o"};